import styled from 'styled-components';
import { Link, animateScroll as scroll } from "react-scroll";
import ArrowDownIcon from "../../res/icons/arrow-down-white.svg";

const Container = styled.div.attrs({ className: "triangle-scroll-to-button" })`
    width: 180px;
    height: 180px;
    position: absolute;
    top: ${({verticalPosition}) => verticalPosition == "top" ? 0 : null};
    bottom: ${({verticalPosition}) => verticalPosition == "bottom" ? 0 : null};
    left: 50%;
    margin: ${({verticalPosition}) => verticalPosition == "top" ? "-90px 0 0 -90px" : "0 0 -90px -90px"};
    z-index: 3;
    display: flex;
    justify-content: flex-start;
    align-items: start;
    transform: ${({verticalPosition}) => verticalPosition == "top" ? "rotate(-135deg)" : "rotate(45deg)"};

    .inner-triangle {
        width: 180px;
        height: 180px;
        border-left: 12px solid var(--brand);
        border-top: 12px solid var(--brand-3);
        position: absolute;
        bottom: 0;
        left: 50%;
        margin: 0 0 0 -90px;
        z-index: 2;
        background: var(--brand-2);
        display: flex;
        justify-content: flex-start;
        align-items: start;
        transition: 0.3s;
        cursor: pointer;
        box-sizing: border-box;

        img {
            width: 3rem;
            height: 3rem;
            transform: rotate(-45deg);
            position: relative;
            top: 35px;
            left: 35px;
        }

        &::after {
            content: "${({label}) => label}";
            position: absolute;
            top: -2rem;
            // right: 30%;
            width: 100%;
            text-align: center;
            color: var(--black);
            font-weight: bold;
            transform: rotate(180deg);
        }
    }

    .outer-triangle {
        width: 220px;
        height: 220px;
        border: 4px solid var(--yellow);
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        background: transparent;
        display: flex;
        transition: 0.3s;
        margin: 80px 0 0 80px;
        cursor: pointer;
        box-sizing: border-box;
    }

    &:hover > .inner-triangle {
        border-width: 16px;
        &::after {
            display: none;
        }
    }

    &:hover > .outer-triangle {
        margin: -20px 0 0 -20px;
    }

    // @media screen and (max-width: 600px) {
    //     display: none;

    //     .outer-triangle {
    //         display: none;
    //     }
    // }

    // @media screen and (max-height: 500px) {
    //     display: none;

    //     .outer-triangle {
    //         display: none;
    //     }
    // }

    // @media screen and (max-width: 800px) and (max-height: 550px) {
    //     display: none;

    //     .outer-triangle {
    //         display: none;
    //     }
    // }
`

export default function TriangleScrollToButton({ scrollTarget, verticalPosition, label }) {
    return (
        <Container
            onClick={() => scroll.scrollTo(scrollTarget, { containerId: "app-content", duration: 1000, delay: 200 })}
            verticalPosition={verticalPosition}
            label={label}
        >

            <div className='outer-triangle'>

            </div>

            <div className='inner-triangle'>
                <img src={ArrowDownIcon} />
            </div>

        </Container>
    )
}